import React from "react";

const ErrorMessage = ({ message }) => (
  <p className="formSU">{message}</p>
);

export default ErrorMessage;